// extracted by mini-css-extract-plugin
export default {"wrapper":"Select_wrapper__sP92j","select":"Select_select__02e1l"};